import { InputLeftAddon } from '@chakra-ui/react';
export default InputLeftAddon;